import React, { useState, createContext, useContext, ReactNode } from "react";
import { ProSidebarProvider } from "react-pro-sidebar";
import MyProSidebar from "./MyProSidebar";

interface SidebarContextType {
  sidebarRTL: boolean;
  setSidebarRTL: (rtl: boolean) => void;
  sidebarBackgroundColor: string | undefined;
  setSidebarBackgroundColor: (color: string | undefined) => void;
  sidebarImage: string | undefined;
  setSidebarImage: (image: string | undefined) => void;
  isTourActive: boolean;
  setIsTourActive: (active: boolean) => void;
}

const SidebarContext = createContext<SidebarContextType>({
  sidebarRTL: false,
  setSidebarRTL: () => {},
  sidebarBackgroundColor: undefined,
  setSidebarBackgroundColor: () => {},
  sidebarImage: undefined,
  setSidebarImage: () => {},
  isTourActive: false,
  setIsTourActive: () => {},
});

export const MyProSidebarProvider = ({ children }: { children: ReactNode }) => {
  const [sidebarRTL, setSidebarRTL] = useState(false);
  const [sidebarBackgroundColor, setSidebarBackgroundColor] = useState<
    string | undefined
  >(undefined);
  const [sidebarImage, setSidebarImage] = useState<string | undefined>(
    undefined
  );
  const [isTourActive, setIsTourActive] = useState(false);

  return (
    <ProSidebarProvider>
      <SidebarContext.Provider
        value={{
          sidebarBackgroundColor,
          setSidebarBackgroundColor,
          sidebarImage,
          setSidebarImage,
          sidebarRTL,
          setSidebarRTL,
          isTourActive,
          setIsTourActive,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: sidebarRTL ? "row-reverse" : "row",
          }}
        >
          <MyProSidebar />
          <div style={{ flex: 1, minWidth: 0, visibility: isTourActive ? "hidden" : "visible" }}>
            {children}
          </div>
        </div>
      </SidebarContext.Provider>
    </ProSidebarProvider>
  );
};

export const useSidebarContext = () => useContext(SidebarContext);
